const moment = require('moment');
const {queryObject, pluckKeysExcept, decodeObservable} = require("helpers/object");
const Trans = require('components/trans/Trans')
const env = require("services/env");

function format(num, decimals = 0, min_decimals = 1) {
    if (num === null || num === undefined) {
        return 0;
    }

  let thousandSeparator = env.get('currency.thousand_separator');
  let decimalSeparator = env.get('currency.decimal_separator');

    if(typeof num === 'string'){
        num = parseFloat(num);
    }

    if(num < 10){
        decimals = min_decimals;
    }

    if(num === 0){
        return 0;
    }

    let numStr = num.toFixed(decimals);

    if (decimals > 0) {
      let decimalSeparatorIndex = numStr.indexOf(".");
      let decimalValue = numStr.substring(decimalSeparatorIndex + 1);
      numStr = numStr.substring(0, decimalSeparatorIndex);

      if (parseInt(decimalValue) > 0) {
        numStr = numStr + decimalSeparator + decimalValue;
      }
    }

    return numStr.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + thousandSeparator);
}


numberFormat = (number, max = 2, min = 2) => {
	return format(number, max, min);
}

moneyFormat = (number, max = 2, min = 2, appendAlphaCode = true, addPrefixSuffix = false) => {
	const value = numberFormat(number, max, min);

    if (appendAlphaCode === true) {
      const alphaCode = env.get('currency.alpha_code');
      return `${value} ${alphaCode}`;
    }
    else if (addPrefixSuffix === true) {
      const prefix = env.get('currency.prefix');
      const suffix = env.get('currency.suffix');
      return `${prefix}${value}${suffix}`;
    }

	return value;
}

enumerateWithRest = (elements, max = 2) => {
	const extras = Math.min(elements.length - max, 0);
	return elements.slice(0, max).join(", ") + (extras > 0 ? ` +${extras}` : "");
}

roundToFives = (n) => {
	const division = n / 5;
	const whole = Math.floor(division);
	const rest = Math.round(division - whole);

	return (whole + rest) * 5;
}

firstToUpper = (string) => {
	if (typeof string !== 'string') return string;
	return string.replace(/^\w/, c => c.toUpperCase());
}

allToUpper = (string) => {
	if (typeof string !== 'string') return string;
	return string.replace(/\b(\w)/g, c => c.toUpperCase());
}

dateFormat = (DT, outputFormat = "DD.MM.YYYY") => {

	if(DT){

		let formats = [
			"YYYY-MM-DD HH:mm:ss",
			"YYYY-MM-DD",
			"YYYYMMDDHHmmss"
		];

		let orgDate = DT.date ? DT.date:DT;

		for (let index = 0; index < formats.length; index++) {
			const format = formats[index];
			let date = moment(orgDate, format).format(outputFormat);
			if(date != 'Invalid date'){
				return date;
			}
			
		}

	}

}

statusDecode = (status, label = null) => {
	switch (status) {
		case "published":
			return {
				type: "green",
              label: label ? label: translate('Udgivet')
			}
		case "draft":
			return {
				type: "yellow",
				label: translate('Kladde')
			}
		case "deleted":
			return {
				type: "red",
				label: label ? label: translate('Slettet')
			}
		case "aktiv":
			return {
				type: "green",
				label: label ? label: translate('Aktiv')
			}
		case "inaktiv":
			return {
				type: "red",
				label: label ? label: translate('Inaktiv')
			}
		case "active":
			return {
				type: "green",
				label: label ? label: translate('Aktiv')
			}
		case "inactive":
			return {
				type: "red",
				label: label ? label: translate('Inaktiv')
			}
		case "expired":
			return {
				type: "red",
				label:  translate('Udløbet')
			}
		case 'succeeded':
			return {
				type: "green",
				label:  translate('Succeeded') ,
			}
		case 'failed':
			return {
				type: "red",
				label:  translate('Fejlet') ,
			}
		case 'ignored':
			return {
				type: "yellow",
				label:  translate('Ignored') ,
			}
		case 'accepted':
			return {
				type: "green",
				label:  translate('Accepteret') ,
			}
		case 'rejected':
			return {
				type: "red",
				label:  translate('Afvist') ,
			}
		case 'requested':
			return {
				type: "yellow",
				label:  translate('Anmodet') ,
			}

		default:
			return {
				type: "grey",
				label: label ? label:status
			}
	}
}

dayToString = (number) => {
	switch (number) {
		case 0:
			return  translate('Mandag') ;
		case 1:
			return  translate('Tirsdag') ;
		case 2:
			return  translate('Onsdag') ;
		case 3:
			return  translate('Torsdag') ;
		case 4:
			return  translate('Fredag') ;
		case 5:
			return  translate('Lørdag') ;
		case 6:
			return  translate('Søndag') ;
		default:
			return "Error";
	}
}

urlSlug = (string) => {
	if (typeof string !== 'string') return string;

	const val = string
		.toLowerCase()
		.replace(/[ ]/g, '-')
		.replace(/[.]/g, '');
	return encodeURIComponent(val);
}

module.exports = {
	numberFormat,
	moneyFormat,
	enumerateWithRest,
	roundToFives,
	dateFormat,
	statusDecode,
	firstToUpper,
	allToUpper,
	urlSlug,
	dayToString
};
